<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <BaseTab>
      <v-tab>Histórico de Ações</v-tab>
      <v-tab-item class="pt-8">
        <v-row class="py-5 px-4 mb-5" v-if="hasCurrentHistoricalActions">
          <v-col
            cols="12"
            sm="5"
            class="justify-center d-flex justify-sm-start pl-sm-4"
          >
            <p class="primary--text font-weight-bold body-1 mb-sm-0">
              Criada por
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start"
          >
            <p class="gray--text body-2 mb-sm-0">
              {{ currentHistoricalActions.criada_por.nome }}
              <v-tooltip bottom content-class="tooltip-historical">
                <template v-slot:activator="{ on }">
                  <v-icon color="secondary" size="10" v-on="on" class="pl-1">
                    fa-info-circle
                  </v-icon>
                </template>
                <v-row>
                  <v-col cols="12" class="px-4 py-3">
                    <p
                      class="white--text tooltip-label-text mb-0"
                      style="white-space: pre-line"
                    >
                      Email:
                      {{ currentHistoricalActions.criada_por.email }} Telefone:
                      {{ currentHistoricalActions.criada_por.telefone }}
                    </p>
                  </v-col>
                </v-row>
              </v-tooltip>
            </p>
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start"
          >
            <p class="gray--text body-2 mb-sm-0">
              {{
                formatIsoDateToDDMMYYYYHHMM(currentHistoricalActions.criada_em)
              }}
            </p>
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start pr-sm-4"
          >
            <div class="historic-quotation__button" />
          </v-col>
        </v-row>
        <div v-for="(item, key) in listHistoricalActions" :key="key">
          <HistoricalActions :item="item" class="mb-5" />
        </div>
      </v-tab-item>
      <v-tab v-if="hasPolicy">Memória de Cálculo</v-tab>
      <v-tab-item class="pt-8" v-if="hasPolicy">
        <HeaderCostQuotation :info="currentQuotation" />
        <ResumeQuotation :info="currentQuotation" :show-button="false" />
        <QuotationSelectInsuranceCompany
          :value="insuranceCompany"
          :info="currentQuotation"
          disabled
          :disabled-edit=true
          @modal="showModalDetailsRefuseInsurance"
        />
        <ModalDetailsRefuseInsurance
          v-model="modalDetailsRefuseInsurance"
          @close="closeModalDetailsRefuseInsurance"
          :item="itemDetailsRefuseInsurance"
          v-if="itemDetailsRefuseInsurance"
        />
      </v-tab-item>
      <v-tab v-if="hasAPILogs">CHAMADAS DE API</v-tab>
      <v-tab-item class="pt-8" v-if="hasAPILogs">     
        <v-row>
          <v-spacer />
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start pr-sm-4"
          >
            <div class="historic-quotation__button" />
          </v-col>
        </v-row>        
        <div v-for="(item, key) in listHistoricalActionsApiCalls" :key="key">
          <HistoricalActionsApiCalls :item="item" class="mb-5" />          
        </div>        
      </v-tab-item>
    </BaseTab>
  </Main>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import HistoricalActions from "../components/HistoricalActions";
import HistoricalActionsApiCalls from "../components/HistoricalActionsApiCalls";
import HeaderCostQuotation from "../components/HeaderCostQuotation";
import ResumeQuotation from "../components/ResumeQuotation";
import QuotationSelectInsuranceCompany from "../components/QuotationSelectInsuranceCompany";
import _ from "lodash";
import { formatIsoDateToDDMMYYYYHHMM } from "@/utils/formats.js";
import ModalDetailsRefuseInsurance from "../components/ModalDetailsRefuseInsurance";
import ModalDetailsInsuranceMixin from "@/mixins/ModalDetailsInsuranceMixin";
export default {
  data: () => ({
    breadcrumb: [],
    formatIsoDateToDDMMYYYYHHMM,
    show: false,
  }),
  mixins: [LoadingRequest, ModalDetailsInsuranceMixin],
  components: {
    HistoricalActions,
    HistoricalActionsApiCalls,
    HeaderCostQuotation,
    ResumeQuotation,
    QuotationSelectInsuranceCompany,
    ModalDetailsRefuseInsurance,
},
  created() {
    Promise.all([this.fetchHistoricalActions(), this.fetchQuotation(), this.fetchHistoricalActionsApiCalls(this.$route.params.id)]);
  },
  computed: {
    ...mapState("quotation", ["currentQuotation", "currentHistoricalActions", "apiCalls"]),
    ...mapState(["userPermissions"]),
    hasCurrentHistoricalActions() {
      return !_.isEmpty(this.currentHistoricalActions);
    },
    listHistoricalActions() {
      return (
        this.hasCurrentHistoricalActions &&
        this.currentHistoricalActions.historico_minutas
      );
    },
    listHistoricalActionsApiCalls() {
      return (
        this.apiCalls
      );
    },
    hasPolicy() {
      return (
        !_.isEmpty(this.currentQuotation) &&
        this.currentQuotation != null &&
        this.currentQuotation.passos !== undefined &&
        this.currentQuotation.passos != null &&
        this.currentQuotation.passos.some(
          p => p.id == "apolice_emitida" && p.status.id == "realizado"
        )
      );
    },
    insuranceCompany() {
      return this.hasPolicy
        ? this.currentQuotation.custos.find(
            x => x.seguradora.id == this.currentQuotation.apolice.seguradora.id
          )
        : null;
    },
    hasAPILogs() {
      return this.listHistoricalActionsApiCalls != null && 
      this.listHistoricalActionsApiCalls.length > 0 &&
      this.userPermissions.acoes.find(x => x.id == "visualizar_logs_chamadasAPI");
    },
  },
  methods: {
    ...mapActions("quotation", [
      "requestCurrentQuotation",
      "requestHistoricalActions",
      "requestHistoricalActionsApiCalls"
    ]),
    fetchQuotation() {
      if (_.isEmpty(this.currentQuotation)) {
        this.withLoading(this.requestCurrentQuotation(this.$route.params.id));
      } else {
        this.updateBreadcrumb();
      }
    },
    fetchHistoricalActions() {
      this.withLoading(this.requestHistoricalActions(this.$route.params.id));
    },
    fetchHistoricalActionsApiCalls() {
      this.withLoading(this.requestHistoricalActionsApiCalls(this.$route.params.id));
    },
    previousPage() {
      this.$router.push({
        name: "quotation element",
        params: { id: this.$route.params.id }
      });
    },
    updateBreadcrumb() {
      this.breadcrumb = [
        {
          text: `Cotação - ${this.currentQuotation.numero}`,
          to: "quotation element"
        }
      ];
    }
  },
  watch: {
    currentQuotation() {
      this.updateBreadcrumb();
    }
  }
};
</script>
<style lang="sass">
.tooltip-historical
  border-radius: 2px
  background-color: #676778
  box-shadow: 0 7px 10px 0 rgba(44,48,64,0.21)
  max-width: 250px
</style>
